<template>
  <el-dialog
    :visible.sync="elevatorDialogVisible"
    width="1010px"
    top="6vh"
    :before-close="closeElevatorDialog"
  >
    <template slot="title"> <title-icon />{{ title }} </template>
    <el-dialog
      width="1000px"
      top="6vh"
      title="视频回放"
      :visible.sync="innerVisible"
      append-to-body
      :before-close="closeDialog"
    >
      <div class="historyVideo">
        <div class="time">
          <p>
            <label>选择时间范围：</label>
            <el-date-picker
              v-model="value1"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              @change="getRecordvideoAuthorization"
              >
            </el-date-picker>
            <!-- <el-time-picker
              is-range
              v-model="value1"
              range-separator="-"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
              format="HH:mm:ss"
              @change="getRecordvideoAuthorization"
            >
            </el-time-picker> -->
          </p>
        </div>
        <cus-player ref="historyVideo" v-if="innerVisible" height="500px" width="940px"></cus-player>
      </div>
    </el-dialog>
    <div class="dialog-center">
      <div class="center">
        <div class="floor">
          <i
            class="el-icon-caret-top"
            :class="{ active: elevatorData.direction === 2 }"
          ></i>
          <div>{{ elevatorData.currentFloor }}F</div>
          <i
            class="el-icon-caret-bottom"
            :class="{ active: elevatorData.direction === 1 }"
          ></i>
        </div>
        <div class="img">
          <img :src="img" />
        </div>
        <div class="status">
          <p>
            运行状态： <span>正常</span>
            <i :class="{ stop: elevatorData.runModel === 0 }"></i>
          </p>
        </div>
      </div>
      <div class="video-box">
        <cus-player ref="video" v-if="elevatorDialogVisible"></cus-player>
      </div>
    </div>
    <div class="history-btn">
      <el-button @click="showHistoryVideo">视频回放</el-button>
    </div>
    <!-- <div class="time">
      <p>
        <label>选择时间范围：</label>
        <el-time-picker
          is-range
          v-model="value1"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
          format="HH:mm:ss"
          @change="getLatestLiftRunStatistics"
        >
        </el-time-picker>
      </p>
      <p>
        电梯{{ $moment(value1[0]).format("HH:mm:ss") }}-
        {{ $moment(value1[1]).format("HH:mm:ss") }}的运行次数: {{ runTimes }}
      </p>
    </div> -->
  </el-dialog>
</template>
<script>
import CusPlayer from '@/views/iori/camera/CusPlayer'
import { queryLiftDetail, getLatestLiftRunStatistics, getRecordvideoAuthorization } from '@/api/business/base/tenant/fireFightingSystem'

export default {
  components: {
    CusPlayer
  },
  props: {
    // 显示
    elevatorDialogVisible: {
      type: Boolean
    },
    // 设备信息
    registerCode: {
      type: String,
    },
    deviceEui: {
      type: String
    },
    title: {
      type: String
    }
  },
  computed: {
    isShow() {
      return this.elevatorDialogVisible;
    }
  },
  watch: {
    isShow: function () {
      this.isShowDialog();
    }
  },
  data() {
    return {
      img: require('@/assets/images/elevator_off.png'),
      isUP: true,
      elevatorData: {},
      timer: null,
      httpUrl: null,
      runTimes: null,
      value1: [this.$moment(new Date()).format('YYYY-MM-DD 00:00:00'), this.$moment(new Date()).format('YYYY-MM-DD 23:59:59')],
      innerVisible: false
    }
  },
  created() {
    if (this.elevatorDialogVisible) {
      this.queryLiftDetail()
      this.getLatestLiftRunStatistics()
      this.timer = setInterval(() => {
        this.queryLiftDetail()
        this.getLatestLiftRunStatistics()
      }, 3000);
    }
  },

  methods: {
    isShowDialog() {
      if (this.elevatorDialogVisible) {
        clearInterval(this.timer)
        this.queryLiftDetail()
        this.getLatestLiftRunStatistics()
        this.timer = setInterval(() => {
          this.queryLiftDetail()
          this.getLatestLiftRunStatistics()
        }, 3000);

      }
    },
    closeDialog() {
       this.innerVisible = false
       this.value1 = [this.$moment(new Date()).format('YYYY-MM-DD 00:00:00'), this.$moment(new Date()).format('YYYY-MM-DD 23:59:59')]
    },
    // 视频回放
    showHistoryVideo() {
      this.innerVisible = true
      this.getRecordvideoAuthorization()
    },
    // 视频回放
    getRecordvideoAuthorization() {
      if (!this.value1) {
        this.value1 = [this.$moment(new Date()).format('YYYY-MM-DD 00:00:00'), this.$moment(new Date()).format('YYYY-MM-DD 23:59:59')]
      }
      const params = {
        beginTime: Date.parse(new Date(this.value1[0])) / 1000,
        endTime: Date.parse(new Date(this.value1[1])) / 1000,
        registerCode: this.registerCode
      }
      getRecordvideoAuthorization(params).then(res => {
        const httpUrl = 'ws://47.108.92.56:8866/live?url=' + res.data.url
        this.$refs.historyVideo.createPlayer(httpUrl, true, 0)
      })
    },
    // 运行次数
    getLatestLiftRunStatistics() {
      const params = {
        beginTime: Date.parse(new Date(this.value1[0])) / 1000,
        endTime: Date.parse(new Date(this.value1[1])) / 1000,
        registerCodes: [this.registerCode]
      }
      getLatestLiftRunStatistics(params).then(res => {
        if (res.data.length > 0) {
          this.runTimes = res.data[0].runTimes
        }
      })
    },
    queryLiftDetail() {
      queryLiftDetail({ registerCode: this.registerCode }).then(res => {
        this.elevatorData = res.data
        if (this.elevatorData.doorStatus === 2) {
          this.img = require('@/assets/images/elevator_off.png')
        } else {
          this.img = require('@/assets/images/elevator_on.png')
        }
        if (!this.httpUrl && this.elevatorDialogVisible) {
          this.httpUrl = 'ws://47.108.92.56:8866/live?url=' + res.data.videoList[0].rtspUrl
          this.$refs.video.createPlayer(this.httpUrl, true, 0)
        }
      })
    },
    closeElevatorDialog() {
      this.httpUrl = null
      clearInterval(this.timer)
      this.$emit('update:elevatorDialogVisible', false)
    },
  }
}
</script>

<style lang="scss">
.dialog-center {
  display: flex;
}
.floor {
  display: flex;
  width: 324px;
  margin: 0 auto;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
  i {
    font-size: 40px;
    color: rgb(37, 105, 231);
  }
  .active {
    color: rgb(33, 243, 114);
  }
  div {
    font-size: 20px;
    font-weight: 500;
  }
}
.img {
  text-align: center;
}
.time {
  display: flex;
  line-height: 40px;
  height: 60px;
  p {
    margin-right: 20px;
  }
}
.status {
  text-align: center;
  width: 300px;
  margin: 0 auto;
  p {
    &:last-child {
      i {
        display: inline-block;
        vertical-align: text-bottom;
        margin-left: 10px;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: rgb(33, 243, 114);
      }
      .stop {
        background-color: #ccc;
      }
      .alarm {
        background-color: red;
      }
    }
  }
}
.video-box {
  width: 600px;
  height: 443px;
  margin-left: 20px;
  margin-top: 44px;
}
.historyVideo {
  height: 572px;
}
.history-btn {
  position: absolute;
  left: 374px;
  bottom: 12px;
}
</style>